import { HouseholdTier } from "@/schema"
import { NULL_SENTINEL_VALUE } from "@ui/forms/inputs/select-input"
import { Button, CustomSelectTrigger, Select, SelectContent, SelectItem } from "@ui/shad"
import { ChevronDown, Layers, Loader2 } from "lucide-react"

import { useTierLabels } from "@/hooks/api/books/queries"
import { useBookId } from "@/hooks/use-book-id"

interface BulkTierSelectionProps {
  onSelect: (tier: HouseholdTier | null) => void
  isDisabled?: boolean
  isUpdating?: boolean
}

export default function BulkTierSelection({ onSelect, isDisabled, isUpdating }: BulkTierSelectionProps) {
  const bookId = useBookId()
  const { tierLabelsForDisplay } = useTierLabels(bookId)

  function handleSelect(value: string) {
    const tier = value === NULL_SENTINEL_VALUE ? null : (Number(value) as HouseholdTier)
    onSelect(tier)
  }

  const tierOptions = [
    { value: NULL_SENTINEL_VALUE, label: "No tier" },
    ...tierLabelsForDisplay.map((tier: { value: number; label: string }) => ({
      value: String(tier.value),
      label: tier.label,
    })),
  ]

  return (
    <Select onValueChange={handleSelect} disabled={isDisabled}>
      <CustomSelectTrigger asChild>
        <Button variant="inverse" size="sm" disabled={isDisabled}>
          {isUpdating ? <Loader2 className="animate-spin" /> : <Layers />}
          Change tier
          <ChevronDown className="h-3 w-3" />
        </Button>
      </CustomSelectTrigger>
      <SelectContent>
        {tierOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
